import classNames from "classnames"
import { FC, useState } from "react"
import { FormGroup, Label } from "reactstrap"
import { v4 } from "uuid"

type LabeledCheckboxProps = {
    label: string | JSX.Element
    checked: boolean
    onChange: (checked: boolean) => void
    className?: string
    small?: boolean
    disabled?: boolean

    /**
     * Arbitrary element that will be appended after the label.
     */
    infoSuffix?: JSX.Element
}

export const LabeledCheckboxInput: FC<LabeledCheckboxProps> = (props) => {

    const [elementId] = useState(v4())

    return (
        <FormGroup
            className={classNames(
                "m-0 d-flex align-items-center",
                { "small": props.small },
                props.className
            )}
        >
            <input
                disabled={props.disabled}
                id={elementId}
                type="checkbox"
                checked={props.checked}
                onChange={(e) => props.onChange(e.target.checked)}
            />

            <Label
                className="m-0 p-0 ml-2"
                style={{ lineHeight: 0 }}
                htmlFor={elementId}
            >
                {props.label}
            </Label>

            {props.infoSuffix && props.infoSuffix}
        </FormGroup>
    )
}
